export default "__VITE_ASSET__5LVMKKMI__"